import { useTranslation } from '~/i18n'
import Text from '~/components/UI/Text'
import styled from 'styled-components'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import getcdn from '~/modules/get_cdn_link'
import breakpoints from '~/components/UI/breakpoints'
import GooglePlayButton from '~/components/UI/GooglePlayButton'
import IosButton from '~/components/UI/IosButton'
import Img from '../UI/Image'

const Intro = () => {
  const [t] = useTranslation()

  return (
    <Root>
      <Container>
        <Row>
          <Col md={8}>
            <Title bold size={36} mdSize={48} lgSize={58}>
              {t('Phá bỏ rào cản đầu tư')}
            </Title>
            <Subtitle bold size={18}>
              {t('Infina - Nền tảng đầu tư và tích lũy cho mọi người')}
            </Subtitle>
            <ExplanTitle>
              {t(
                'Không còn sự phức tạp, không yêu cầu số vốn lớn, hạn chế rủi ro thấp nhất, giúp mọi người bắt đầu hành trình đầu tư một cách dễ dàng.'
              )}
            </ExplanTitle>
            <DownloadAppView>
              <QrCodeImage src={getcdn('/img/qr_code.jpeg')} alt="qr infina" />
              <DownloadAppButtons>
                <IosButton />
                <GooglePlayButton />
              </DownloadAppButtons>
            </DownloadAppView>
          </Col>

          <Col md={4}>
            <Title bold size={36} mdSize={48} lgSize={58}>
              <Banner src={getcdn('/images/home/banner2.png')} alt="home_intro_background" />
            </Title>
          </Col>
        </Row>
      </Container>
    </Root>
  )
}

export default Intro

//#region
const Title = styled(Text)`
  text-align: center;

  ${breakpoints.md} {
    text-align: left;
  }
`

const QrCodeImage = styled(Img)`
  display: none;
  box-shadow: 0 2px 4px 0 rgba(0, 72, 216, 0.1);
  background-color: transparent;
  border: 5px solid white;
  border-radius: 2px;

  ${breakpoints.md} {
    display: block;
    height: 95px;
    width: 95px;
    margin-right: 15px;
  }
`

const Subtitle = styled(Text)`
  text-align: center;
  font-weight: normal;

  ${breakpoints.md} {
    text-align: left;
    font-weight: bold;
  }
`

const ExplanTitle = styled(Text)`
  display: none;

  ${breakpoints.md} {
    display: block;
  }
`

const DownloadAppView = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 12px;
`

const DownloadAppButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;

  > * + * {
    margin-left: 10px;
  }

  ${breakpoints.md} {
    flex-direction: column;
    justify-content: space-between;
   
    > * + * {
      margin-left: 0;
    }
  }
`

const Banner = styled.img`
  width: 100%;
  transform: scale(1.2);
  margin-top: 35px;
`

const Root = styled.div``
//#endregion
